@if (shouldDisplayValidResult == true && cartValidationResult?.isValid == true) {
  <div class="cart-preview-validation-text valid" i18n="@@CartValidationResultCartIsValid">Cart is valid</div>
}

@if (hasItemValidationErrors == true) {
  <div class="cart-preview-validation-text invalid" i18n="@@CartValidationResultCartHasItemValidationErrors">Some cart items need to be adjusted.</div>
}

@if (cartValidationResult?.cartErrorList != undefined) {
  @for (cartValidationError of cartValidationResult!.cartErrorList; track cartValidationError) {
    @switch (cartValidationError.errorType) {
      @case (eCartValidationError.DeliveryAddressIsInvalid) {
        <div class="cart-preview-validation-text invalid" i18n="@@CartValidationResultCartDeliveryAddressIsInvalid">The delivery address is invalid. Please select another address.</div>
      }
      @case (eCartValidationError.DeliveryDateIsInvalid) {
        <div class="cart-preview-validation-text invalid" i18n="@@CartValidationResultCartDeliveryDateIsInvalid">Please set a fitting delivery date.</div>
      }
      @case (eCartValidationError.Unauthorized) {
        <div class="cart-preview-validation-text invalid" i18n="@@CartValidationResultCartUnauthorized">Unauthorized</div>
      }
      @case (eCartValidationError.ServiceUnavailable) {
        <div class="cart-preview-validation-text invalid" i18n="@@CartValidationResultCartServiceUnavailable">A service is currently unavailable so we cannot validate your shopping cart.</div>
      }
      @case (eCartValidationError.MinimumOrderAmountNotReached) {
        <div class="cart-preview-validation-text invalid">
          <span i18n="@@CartValidationResultCartMinimumOrderAmountNotReached">Minimum Order Amount of {{ (cartValidationError.errorDetails.minimumOrderAmount | number:"1.2-2") }}{{ eCurrency.Euro | eCurrencyToSymbol }} is not reached</span>
        </div>
      }
      @default {
        <div class="cart-preview-validation-text invalid" i18n="@@CartValidationResultCartMissingEnumCaseImplementation">Cart validation error {{ eCartValidationError[cartValidationError.errorType] }}</div>
      }
    }
  }
}

<!-- <pre>{{ cartValidationResult | json}}</pre> -->
